import { useNavigate } from 'react-router-dom'
import { useCallback } from 'react'
import LocalStorage from '@forwardflow/services/LocalStorage'

/**
 * Custom hook for handling user logout while preserving tour state.
 * Extracts logout logic to maintain separation of concerns.
 * 
 * @returns Object containing logout function
 */
export const useLogout = () => {
   const navigate = useNavigate()

   const logout = useCallback(() => {
      // Preserve tour completion state
      const isTourDone = LocalStorage.get('isTourDone')
      const isCampaignTourDone = LocalStorage.get('isCampaignTourDone')

      // Clear all local storage
      LocalStorage.clear()

      // Restore tour state
      if (isTourDone) LocalStorage.put('isTourDone', isTourDone)
      if (isCampaignTourDone)
         LocalStorage.put('isCampaignTourDone', isCampaignTourDone)

      // Navigate to logout and reload
      navigate('/logout')
      window.location.reload()
   }, [navigate])

   return { logout }
}

